<template>
  <base-view
      :permiteCadastrar="false"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">
    
    <EfetivarIncricaoDialog 
      v-model="efetivarIncricaoDialogOpened"
      :edicaoEvento="edicaoEvento"
      :autenticacao="autenticacao"
      :autenticado="autenticado"
      @onSave="() => this.$refs.dataTable.refresh()"/>

    <div>
      <EdicoesAbertasDataTable ref="dataTable"
        :search-values="searchValues"
        @click:detalheInscricao="efetivarIncricao"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import EdicoesAbertasDataTable from "../../components/shared/datatables/EdicoesAbertasDataTable";
import EfetivarIncricaoDialog from "@/views/EventoInscricao/components/EfetivarIncricaoDialog";
import BaseView from "../BaseView";
import {findAll as findAllEvento} from '../../api/evento';
import {findAll as findAllEventoTipo} from '../../api/eventoTipo';
import {findInscricaoPorToken} from "@/api/eventoInscricao";
import {mapActions, mapGetters} from "vuex";
import {ApiError} from "@/api/core";

export default {
  name: "EdicoesAbertas",
  components: {BaseView, EdicoesAbertasDataTable, EfetivarIncricaoDialog},
  data() {
    return {
      item: null,
      edicaoEvento: {},
      autenticacao: {},
      autenticado: false,
      loading: false,
      editDialogOpened: false,
      efetivarIncricaoDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'Tipo Evento',
          column: 'idEventoTipo',
          type: 'autocomplete',
          optionsFactory: (search) => findAllEventoTipo(1,{
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },
        {
          name: 'Evento',
          column: 'idEvento',
          type: 'autocomplete',
          optionsFactory: (search) => findAllEvento(1,{
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','token','isAuthenticated','nivelUsuarioLogado']),
  },
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    async efetivarIncricao(objeto) {
      try {
        this.loading = true;
        const dadosInscricao = await findInscricaoPorToken(objeto.id);
        let retornoInscricao = {};
        if (dadosInscricao?.current){
          retornoInscricao.inscrito = 1;
          retornoInscricao.idInscricao = dadosInscricao?.current.id || null;          
          retornoInscricao.dtInscricao = dadosInscricao?.current.dtInscricao;
          retornoInscricao.descStatus = dadosInscricao?.current.descStatus;
          retornoInscricao.maisDetalheInscricao = dadosInscricao?.current.maisDetalhe;
          retornoInscricao.cronogramaInscricao = dadosInscricao?.current.cronograma || [];
          retornoInscricao.ofertaDemanda = dadosInscricao?.current.ofertaDemanda || [];          
        }
// console.log('dadosInscricao', edicaoEvento);
        this.edicaoEvento = { ...objeto, ...retornoInscricao };
        this.autenticacao = {
          dadosLogado: {
            token: this.token,
            current: this.user
          },
          encontrou: 1
        };
        this.autenticado = true;

        this.efetivarIncricaoDialogOpened = true;

      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados da Inscrição. Tente Novamente mais tarde. ${err}`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>